import * as Yup from 'yup';

export const validationSchema = Yup.object().shape({
    upcomingExamsNotes: Yup.string()
        .max(300, 'Max 300 characters')
});